import React from "react";
import PouchInput from "components/PouchInput";
import PouchDateInput from "components/PouchDateInput";
import PouchSelect from "components/PouchSelect";
import SortableHeaderCell from "components/SortableHeaderCell";
import { CellProps } from "components/table/Table";
import get from "lodash/get";

const RestrictedCell = ({
  data,
  column,
  meet,
  style,
  getInnerCellAriaLabel,
}: CellProps) => {
  const lifter = data;
  if (lifter.row === "header") {
    return <SortableHeaderCell style={style} column={column} />;
  } else {
    const restrictedDoc = get(lifter, "restricted", {});

    const ariaLabel = getInnerCellAriaLabel
      ? getInnerCellAriaLabel({ data, column })
      : undefined;

    if (column.type === "select") {
      if (!column.options) {
        return null;
      }
      return (
        <div style={style} className="table-cell-inner">
          <PouchSelect
            meet={meet}
            document={restrictedDoc}
            name={column.key}
            value={get(restrictedDoc, column.key)}
            options={column.options}
            ariaLabel={ariaLabel}
          />
        </div>
      );
    } else if (column.type === "date") {
      return (
        <div style={style} className="table-cell-inner">
          <PouchDateInput
            meet={meet}
            documentId={restrictedDoc._id}
            name={column.key}
            value={get(restrictedDoc, column.key)}
            ariaLabel={ariaLabel}
          />
        </div>
      );
    } else {
      return (
        <div style={style} className="table-cell-inner">
          <PouchInput
            type={column.type === "number" ? "number" : "text"}
            meetId={meet._id}
            documentId={restrictedDoc._id}
            name={column.key}
            value={get(restrictedDoc, column.key)}
            ariaLabel={ariaLabel}
          />
        </div>
      );
    }
  }
};

export default RestrictedCell;
